module.exports = __webpack_public_path__ + "static/paper1-cb0005ed6a43333e90747baa14ed32a8.pdf";